<template>
    <div class="scroll_flex_container" v-loading="linePayLoading" element-loading-text="訂單建立中...">
        <div class="column_center_start confirm_page">
            <!-- Add By Bryant 2025/08/18 -->
            <div class="row_start_start w-full mt-3">
                <img :src="avatar" class="avatar" v-if="avatar" />
                <div class="column_start_start grow">
                    <div class="form_cell">
                        <div class="row_center_center label_title">
                            <label for="name">Line暱稱</label>
                            <text class="must">(必填)</text>
                        </div>
                        <input type="text" name="name" placeholder="請輸入暱稱" v-model="userNameInput" />
                    </div>
                    <div class="form_cell">
                        <div class="row_center_center label_title">
                            <label for="name">手機末三碼</label>
                            <text class="must">(必填)</text>
                        </div>
                        <!--
                        <input type="tel" name="phonetail" inputmode="tel" placeholder="請輸入手機末三碼" v-model="userMobileTailInput"
                            maxlength="3" />
                        -->
                        <input type="tel" name="phonetail" inputmode="tel" placeholder="請輸入手機末三碼" v-model="userMobileTailInput"
                            maxlength="3" />
                    </div>
                </div>
            </div>
            <!-- Add By Bryant 2025/08/18 End -->
            <!-- 使用新的統一消費模式組件 -->
            <ConsumptionModeInfo 
                ref="consumptionModeInfo"
                :consumptionMethod="currentConsumptionMethod"
                :editMode="true"
                :syncInvoiceToMember="true"
            />
            <div class="row_center_between" style="width: 100%; padding: 20px 0 10px;">
                <text class="title">餐點列表</text>
                <button class="backToOrdering" @click="backToOrdering">繼續點餐</button>
            </div>
            <div class="column_center_start" style="width: 100%;">
                <ProductConfirm v-for="(product, index) in cart" :product="product" :key="index"
                    @deleteProduct="deleteProduct(index)"></ProductConfirm>
            </div>
            <div class="row_center_between" style="width: 100%; margin: 20px 0; font-size: 18px;">
                <text>共{{ getCartQuantity }}項商品</text>
                <div class="row_center_center">
                    <text style="font-weight: 600;">小計：</text>
                    <text class="text-primary-color" style="font-weight: bold;">${{ getCartTotalPrice }}</text>
                </div>
            </div>
            <!-- 訂單規格 -->
            <div class="w-full column_center_start mb-3" v-if="orderSpecs.length">
                <div class="column_center_start w-full" v-for="(item) in orderSpecs" :key="item.id">
                    <orderSpec :orderSpec="item" />
                </div>
            </div>
            <div class="column_start_start" style="width: 100%; margin-bottom: 20px;">
                <text class="title">訂單備註</text>
                <!--
                <textarea class="order_note" placeholder="輸入訂單備註..." v-model="comment" ref="commentTextarea"
                    @focus="scrollToComment"></textarea>
                -->
                <textarea class="order_note" placeholder="可輸入訂單備註...例如，取餐地點與時間，或其他餐點需求" v-model="comment" ref="commentTextarea"
                    @focus="scrollToComment"></textarea>
            </div>
            <!-- TODO: 目前積點尚未完成 先隱藏 -->
            <div class="column_start_start" style="width: 100%; margin-bottom: 20px;" v-if="false">
                <text class="title">積點折抵</text>
                <div class="row_center_start" style="margin: 10px 0 15px;">
                    <text>持有積點：</text>
                    <text class="text-primary-color">{{ totalPoints }}</text>
                    <text>點</text>
                </div>
                <div class="row_center_start usePoint">
                    <input type="checkbox" v-model="usePoint" />
                    <text>使用折抵</text>
                    <input type="number" v-model="pointQuantity" @focus="scrollToInput" ref="pointInput"
                        inputmode="numeric" placeholder="0" :disabled="!usePoint" />
                    <text>元</text>
                </div>
            </div>
            <!-- TODO: 目前優惠卷尚未完成 先隱藏 -->
            <div class="column_start_start coupons_container" v-if="memberCouponList.length && false">
                <div class="row_center_start">
                    <text class="title">優惠卷({{ memberCouponList.length }})</text>
                    <text class="text-primary-color" style="font-size: 14px; margin-left: 8px;"
                        v-if="getSelectedCoupon">限用一張，已選擇優惠券</text>
                </div>
                <div class="column_center_start coupon_list">
                    <Coupon style="z-index: 999;" v-for="(coupon, index) in memberCouponList" :key="index"
                        :coupon="coupon">
                    </Coupon>
                </div>
            </div>
            <!-- 發票選項已整合到 ConsumptionModeInfo 組件中 -->
            <div class="column_end_start total_price" :style="{ borderTop: displayServiceFee || isDelivery }">
                <!-- TODO: 目前積點 & 優惠卷尚未完成 先隱藏 -->
                <div class="row_center_center">
                    <text>餐點小計：</text>
                    <text class="text-primary-color">${{ getCartTotalPrice }}</text>
                </div>
                <div class="row_center_center mt-2.5" v-if="displayServiceFee && !isDelivery">
                    <text>服務費：</text>
                    <text class="text-primary-color">${{ displayServiceFee }}</text>
                </div>
                <!-- 運費顯示（外送訂單永遠顯示，達到免運門檻時顯示 $0） -->
                <div class="row_center_center mt-2.5" v-if="isDelivery">
                    <text>運費：</text>
                    <text class="text-primary-color">${{ displayShippingFee }}</text>
                    <text v-if="freeShipping > 0 && displayShippingFee == 0" 
                          style="font-size: 14px; color: #4CAF50; margin-left: 8px;">
                        (已達免運門檻)
                    </text>
                    <text v-else-if="freeShipping > 0" 
                          style="font-size: 14px; color: #999; margin-left: 8px;">
                        (滿${{ freeShipping }}免運)
                    </text>
                </div>
                <div class="row_center_center" style="margin: 10px 0;" v-if="false">
                    <text>積點折抵：</text>
                    <text class="text-primary-color">{{ usePoint ? '-' + pointQuantity : 0 }}</text>
                </div>
                <div class="row_center_center" v-if="false">
                    <text>優惠卷：</text>
                    <text class="text-primary-color">{{ getSelectedCouponValue ? '-' + getSelectedCouponValue : 0 }}</text>
                </div>
            </div>
            <div class="row_center_end" style="width: 100%;">
                <text class="title" style="font-size: 24px;">總金額：</text>
                <text class="title text-primary-color" style="font-size: 24px;">${{ displayCartTotalPrice }}</text>
            </div>
            <!-- Modify By Bryant 2025/08/22 Begin
            <div class="row_start_start w-full mt-3">
                <img :src="avatar" class="avatar" v-if="avatar" />
                <div class="column_start_start grow">
                    <div class="form_cell">
                        <div class="row_center_center label_title">
                            <label for="name">Line暱稱</label>
                            <text class="must">(必填)</text>
                        </div>
                        <input type="text" name="name" placeholder="請輸入暱稱" v-model="userNameInput" />
                    </div>
            -->
                    <!-- Modify By Bryant 2025050801
                    <div class="form_cell">
                        <div class="row_center_center label_title">
                            <label for="name">手機門號</label>
                            <text class="must">(必填)</text>
                        </div>
                    -->
                        <!--
                        <input type="tel" name="phone" inputmode="tel" placeholder="請輸入手機門號" v-model="userMobileInput"
                            maxlength="10" />
                        -->
                    <!--
                        <input type="tel" name="phone" inputmode="tel" placeholder="請輸入手機門號" v-model="userMobileInput"
                            maxlength="10" />
                    </div>
                    Modify By Bryant 2025050801 End -->
            <!-- Modify By Bryant 2025/08/22 End
                </div>
            </div>
            -->
        </div>
        <SubSummary :loading="loading" @showSelectPaymentType="showSelectPaymentType" @back="backToOrdering"></SubSummary>
        <PaymentTypePopup v-if="showPaymentTypePopup" @close="showPaymentTypePopup = false" @cashPay="cashPay"
            @linePay="linePay"></PaymentTypePopup>
    </div>
</template>
<script>
import productConfirm from "@/components/store/productConfirm.vue";
import commonUtilities from "@/utils/common.utils";
import coupon from "@/components/coupon/coupon.vue";
import subSummary from "@/components/store/subSummary.vue";
import paymentTypePopup from "@/components/store/paymentTypePopup.vue";
import orderSpec from '@/components/store/orderSpec.vue'
import ConsumptionModeInfo from "@/components/store/ConsumptionModeInfo.vue"
import { mapState, mapGetters } from "vuex";
import config from "@/config";
export default {
    components: {
        ProductConfirm: productConfirm,
        Coupon: coupon,
        SubSummary: subSummary,
        PaymentTypePopup: paymentTypePopup,
        orderSpec: orderSpec,
        ConsumptionModeInfo
    },
    data() {
        return {
            comment: '',
            usePoint: false,
            pointQuantity: 0,
            useCoupon: false,
            CouponValue: 0,
            showPaymentTypePopup: false,
            userNameInput: this.userName,
            userMobileInput: this.userMobile,
            //Add By Bryant 2025/08/25 Begin
            userMobileTailInput: '',
            //Add By Bryant 2025/08/25 End
            userDataChanged: 0,
            loading: true,
            linePayLoading: false,
            altImage: "https://images.okshop.tw/linepay_default_pic.png"
        }
    },
    computed: {
        ...mapState("userData", {
            currentStore: "currentStore",
            memberInfo: "memberInfo",
        }),
        ...mapGetters('coupon', {
            memberCouponList: 'memberCouponList'
        }),
        ...mapGetters("userData", {
            storeCode: 'storeCode',
            totalPoints: 'totalPoints',
            userName: 'name',
            userMobile: 'phone',
            sPhone: 'sPhone',
            telephone: 'telephone',
            avatar: 'avatar'
        }),
        ...mapGetters('cart', {
            getCartQuantity: "cartQuantity",
            getCartTotalPrice: "cartTotalPrice",
            paymentPrice: "paymentPrice",
            getSelectedCouponValue: "selectedCouponValue",
            areaId: 'tableAreaId',
            tableIndex: 'tableIndex',
            displayCartTotalPrice: 'displayCartTotalPrice',
            serviceFee: 'serviceFee',
            displayServiceFee: 'displayServiceFee',
            shippingFee: 'shippingFee',
            displayShippingFee: 'displayShippingFee',
            invoiceTypeIndex: 'invoiceTypeIndex',
            invoiceCarrier: 'invoiceCarrier',
            invoiceVatNumber: 'invoiceVatNumber',
            invoiceNpoBan: 'invoiceNpoBan'
        }),
        ...mapGetters('basic', {
            freeShipping: 'freeShipping'
        }),
        ...mapState('cart', {
            isPointUsed: 'isPointUsed',
            cart: 'cart',
            getSelectedCoupon: "selectedCoupon",
        }),
        getUrlParameters() {
            return this.$route.params
        },
        ...mapGetters('userData', {
            isLogin: 'isLogin',
            isStoreMember: 'isStoreMember'
        }),
        isDelivery() {
            return this.getUrlParameters.method === 'delivery'
        },
        isPickUp() {
            return this.getUrlParameters.method === 'pickUp'
        },
        isDineIn() {
            return this.getUrlParameters.method === 'dineIn'
        },
        isTakeOut() {
            return this.getUrlParameters.method === 'takeOut'
        },
        consumptionPattern() {
            // (LA) 0: 門市內用
            // (LB) 1: 現場外帶
            // (LC) 2: 預約自取
            // (LD) 3: 店家外送
            if (this.isDelivery) return 3
            if (this.isPickUp) return 2
            if (this.isDineIn) return 0
            if (this.isTakeOut) return 1
            return 0
        },
        getPayment() {
            return this.$store.state.cart.payment
        },
        deliveryDate() {
            return this.getPayment.pickupDate
        },
        deliveryTime() {
            return this.getPayment.pickupTime
        },
        deliveryAddress() {
            return this.getPayment.address
        },
        deliveryPhone() {
            return this.getPayment.phone
        },
        orderSpecs() {
            return this.$store.state.order.orderSpecs
        },
        checkUserNameChanged() {
            if (this.userNameInput === this.userName) {
                return false
            }
            return true
        },
        checkUserMobileChanged() {
            if (this.userMobileInput === this.userMobile) {
                return false
            }
            return true
        },
        orderNumber() {
            return this.$store.state.order.orderNumber
        },
        linePayPaymentMethod() {
            return this.$store.getters['payment/linePayPaymentMethod']
        },
        isCashPaymentEnabled() {
            return this.$store.getters['payment/isCashPaymentEnabled']
        },
        paymentUrl() {
            return this.$store.state.payment.paymentUrl
        },
        // 當前消費模式判斷邏輯
        currentConsumptionMethod() {
            if (this.isDelivery) return 'delivery'
            if (this.isPickUp) return 'pickUp'
            if (this.isDineIn) return 'dineIn'
            if (this.isTakeOut) return 'takeOut'
            return 'dineIn' // 預設為內用
        },
        // 取得會員電話的末三碼（優先順序：mobile_phone → s_phone → phone）
        userMobileTail() {
            try {
                // 第一優先：使用 mobile_phone 的末三碼
                if (this.userMobile && this.userMobile !== '') {
                    const phone = String(this.userMobile)
                    return phone.slice(-3)
                }
                // 第二優先：使用 s_phone（店家自填電話）的末三碼
                if (this.sPhone && this.sPhone !== '') {
                    const phone = String(this.sPhone)
                    return phone.slice(-3)
                }
                // 第三優先：使用 telephone（phone 欄位）的末三碼
                if (this.telephone && this.telephone !== '') {
                    const phone = String(this.telephone)
                    return phone.slice(-3)
                }
                return ''
            } catch (error) {
                console.error('取得手機末三碼錯誤:', error)
                return ''
            }
        },
        // 判斷是否需要更新手機末三碼
        shouldUpdateMobileTail() {
            // 如果 mobile_phone、s_phone、phone 其中任一個有資料，則不需要更新
            return !this.userMobile && !this.sPhone && !this.telephone
        },
        // 判斷手機末三碼是否有變更
        checkUserMobileTailChanged() {
            return this.userMobileTailInput && 
                   this.userMobileTailInput !== '' && 
                   this.userMobileTailInput !== this.userMobileTail
        }
    },
    watch: {
        usePoint(val) {
            this.$store.dispatch("cart/setIsPointUsed", val)
        },
        async cart(val) {
            // 檢查如果購屋車被清空時跳回點餐頁面
            if (val.length == 0) {
                commonUtilities.createToastWithTimer('warning', '購物車無商品', '', 2000)
                await commonUtilities.delay(2000)
                this.backToOrdering()
            }
        },
        pointQuantity(val) {
            // 檢查折抵金額是否超過購物車總金額
            if (val > this.getCartTotalPrice) {
                this.pointQuantity = this.getCartTotalPrice
            }
            // 檢查優惠卷加上積點折抵金額是否超過購物車總金額
            if (this.getSelectedCouponValue + val >= this.getCartTotalPrice && this.getSelectedCouponValue >= this.getCartTotalPrice) {
                console.log('優惠卷折抵全部')
                this.pointQuantity = 0
                this.usePoint = false
                this.$store.commit("cart/setPoints", val)
                return
            }
            if (this.getSelectedCouponValue + val > this.getCartTotalPrice) {
                console.log('優惠卷折抵部分')
                this.pointQuantity = this.getCartTotalPrice - this.getSelectedCouponValue
            }

            // 檢查折抵金額是否超過會員持有積點
            if (val > this.totalPoints) {
                this.pointQuantity = this.totalPoints
            }
            // 檢查折抵金額是否小於0
            if (val < 0) {
                this.pointQuantity = 0
            }
            // 檢查折抵金額是否為數字
            if (isNaN(val)) {
                this.pointQuantity = 0
            }
            console.log('折抵金額', val)
            this.$store.commit("cart/setPoints", val)
        },
        getSelectedCouponValue(val) {
            // 檢查優惠卷折抵金額是否超過購物車總金額
            if ((this.pointQuantity + val > this.getCartTotalPrice) && this.usePoint) {
                this.pointQuantity = this.getCartTotalPrice - val
            }

            console.log('優惠卷折抵金額', val)
        },
        getCartTotalPrice() {
            // 購物車總金額小於0時 優先使用優惠卷 在考慮積點折抵
            if (this.getCartTotalPrice < 0 && this.getSelectedCouponValue > this.getCartTotalPrice) {
                this.pointQuantity = 0
            }
        }
    },
    async created() {
        try {
            this.linePayLoading = false
            this.loading = true
            if (!this.isLogin || !this.isStoreMember) {
                this.$router.replace({
                    path: `/${this.storeCode}/store`
                })
            }
            // 如果購物車沒有商品 退回選擇餐點頁
            if (!this.cart.length) this.backToOrdering()
            // 取得商店資訊
            await this.$store.dispatch('basic/fetchStoreInfo')
            // 更新會員資料
            await this.$store.dispatch('userData/fetchMemberInfo')
            this.userNameInput = this.userName
            this.userMobileInput = this.userMobile
            // 使用 getter 初始化手機末三碼
            this.userMobileTailInput = this.userMobileTail
            // 取得優惠卷列表
            // await this.$store.dispatch('coupon/getMemberCoupons')
            this.loading = false
        } catch (e) {
            console.error(e)
        }
    },
    methods: {
        async showSelectPaymentType() {
            try {
                // 先檢查全單規格
                this.orderSpecsValidator()
                
                // 如果是外送模式，驗證外送資訊
                if (this.isDelivery) {
                    const isValid = this.validateDeliveryInfo()
                    if (!isValid) {
                        return  // 驗證失敗，直接返回
                    }
                }
                
                // 驗證發票資訊
                const invoiceValid = this.validateInvoiceInfo()
                if (!invoiceValid) {
                    return  // 驗證失敗，直接返回
                }
                
                // 檢查是否更新暱稱 & 手機
                if (this.checkUserNameChanged) {
                    this.userDataChanged = 1
                    // 更新暱稱
                    await this.updateUserName()
                }
                if (this.checkUserMobileChanged) {
                    this.userDataChanged = 1
                    // 更新手機
                    await this.updateUserMobile()
                }
                // Modify By Bryant 2025050801 //
//                // 檢查手機
//                if (!this.userMobileInput || this.userMobileInput === '') {
//                    throw ('請輸入手機門號')
//                }
//                // 檢查手機號碼格式
//                if (!this.$validator.isValidPhoneNumber(this.userMobileInput)) {
//                    throw ('手機門號格式錯誤')
//                }
                // Modify By Bryant 2025050801 End //

                // Add By Bryant 2025/08/22 Begin

                if (!this.userMobileTailInput || this.userMobileTailInput === '') {
                    throw ('請輸入手機末三碼')
                }

                if (!this.$validator.isValidNumber(this.userMobileTailInput)) {
                    throw ('手機末三碼格式錯誤')
                }

                // 判斷是否需要更新手機末三碼到後端
                if (this.shouldUpdateMobileTail && this.checkUserMobileTailChanged) {
                    this.userDataChanged = 1
                    // 更新手機末三碼
                    await this.updateUserMobileTail()
                }

                // Add By Bryant 2025/08/22 End

            } catch (error) {
                commonUtilities.createToast('error', error)
                return
            }
            if (!this.isCashPaymentEnabled && !this.linePayPaymentMethod) {
                commonUtilities.createToast('error', '目前無可用付款方式')
                return
            }
            this.showPaymentTypePopup = true
        },
        orderSpecsValidator() {
            if (this.orderSpecs.length) {
                for (const orderSpec of this.orderSpecs) {
                    const count = orderSpec.subSpecOptionSelectCount.reduce((acc, el) => acc + el, 0)
                    // 如果是必選
                    if (orderSpec.mustHave && count === 0) {
                        throw `${orderSpec.frontEndDisplayName} 尚未選擇`
                    }
                    // 如果是單選並且是必選
                    if (orderSpec.mustHave && orderSpec.isSingleSelection && count !== 1) {
                        throw `${orderSpec.frontEndDisplayName} 尚未選擇`
                    }
                    // 如果是複選 or 可重複選，加總各項的 quantity 是否符合 minSelect, maxSelect
                    if (!orderSpec.isSingleSelection) {
                        if (count < orderSpec.multiSelectMin) {
                            throw `${orderSpec.frontEndDisplayName} 尚未選擇`
                        }
                        if (count > orderSpec.multiSelectionMax) {
                            throw `${orderSpec.frontEndDisplayName} 選擇數量超過最大值`
                        }
                    }
                }
            }
        },
        async updateUserName() {
            event.stopPropagation()
            const data = structuredClone(this.memberInfo)
            if (this.userNameInput === data.name) {
                return
            }
            // 檢查暱稱
            if (!this.userNameInput || this.userNameInput === '') {
                throw ('請輸入暱稱')
            }
            data.name = this.userNameInput
            await this.$store.dispatch('userData/updateMemberInfo', data)
        },
        async updateUserMobile() {
            event.stopPropagation()
            const data = structuredClone(this.memberInfo)
            if (this.userMobileInput === data.mobile_phone) {
                return
            }
            // 檢查手機
            if (!this.userMobileInput || this.userMobileInput === '') {
                throw ('請輸入手機門號')
            }
            if (!this.$validator.isValidPhoneNumber(this.userMobileInput)) {
                throw ('手機門號格式錯誤')
            }
            data.mobile_phone = this.userMobileInput
            await this.$store.dispatch('userData/updateMemberInfo', data)
        },
        async updateUserMobileTail() {
            event.stopPropagation()
            const data = structuredClone(this.memberInfo)
            
            // 檢查手機末三碼
            if (!this.userMobileTailInput || this.userMobileTailInput === '') {
                throw ('請輸入手機末三碼')
            }
            if (!this.$validator.isValidNumber(this.userMobileTailInput)) {
                throw ('手機末三碼格式錯誤')
            }
            
            // 將手機末三碼同時設定到 s_phone 和 phone 欄位
            data.s_phone = this.userMobileTailInput
            data.phone = this.userMobileTailInput
            
            await this.$store.dispatch('userData/updateMemberInfo', data)
        },
        async cashPay() {
            try {
                if (!this.isCashPaymentEnabled) {
                    throw new Error('現金付款目前未開放')
                }
                // 如果是外送模式，檢查是否需要儲存地址
                if (this.isDelivery) {
                    await this.saveDeliveryAddressIfChecked()
                }
                
                const paymentType = 'cash'
                await this.createOnlineOrder(paymentType)
                this.toPayment(paymentType)
            } catch (error) {
                console.log('create online order error', error)
                commonUtilities.createToast('error', error.message || '建立訂單失敗')
            }
        },
        async linePay() {
            try {
                // 如果是外送模式，檢查是否需要儲存地址
                if (this.isDelivery) {
                    await this.saveDeliveryAddressIfChecked()
                }
                
                const paymentType = 'linePay'
                this.linePayLoading = true
                await this.createOnlineOrder(paymentType)
                // linePay 建立訂單後要使用 linePay 支付結帳
                await this.createLinePayRequest()
                console.log('paymentUrl', this.paymentUrl)
                if (this.paymentUrl) {
                    window.location.href = this.paymentUrl
                }
            } catch (error) {
                console.log('create online order error', error)
                commonUtilities.createToast('error', error.message || '建立訂單失敗')
            } finally {
                this.linePayLoading = false
            }
        },
        async saveDeliveryAddressIfChecked() {
            try {
                const consumptionModeInfo = this.$refs.consumptionModeInfo
                if (!consumptionModeInfo) return
                
                // 呼叫 ConsumptionModeInfo 的方法，進而呼叫 deliveryEdit 的 saveIfChecked
                await consumptionModeInfo.saveDeliveryAddressIfChecked()
                
                // 儲存成功後，重新取得會員資料
                await this.$store.dispatch('userData/fetchMemberInfo')
            } catch (error) {
                console.error('儲存地址失敗:', error)
                throw error
            }
        },
        async createLinePayRequest() {
            const productsInfo = this.cart.map(product => {
                const imageUrl = this.$store.getters['product/getProductImageById'](product.product.id)

                return {
                    id: product.product.id,
                    name: product.product.name,
                    imageUrl: imageUrl || this.altImage,
                    quantity: product.quantity,
                    price: Number(this.$store.getters['cart/productUnitPrice'](product)),
                }
            })

            // 建立額外費用列表（服務費、運費等）
            const additionalFees = []
            
            // 服務費當成一個商品 避免 order_amount 和 products_info 加總金額不一致
            if (this.displayServiceFee > 0) {
                additionalFees.push({
                    id: 'serviceFee',
                    name: '服務費',
                    imageUrl: '',
                    quantity: 1,
                    price: Number(this.displayServiceFee),
                })
            }
            
            // 運費當成一個商品（僅外送模式）
            if (this.displayShippingFee > 0) {
                additionalFees.push({
                    id: 'shippingFee',
                    name: '運費',
                    imageUrl: '',
                    quantity: 1,
                    price: Number(this.displayShippingFee),
                })
            }

            const sendData = {
                order_number: this.orderNumber,
                store_payment_methods_config_id: this.linePayPaymentMethod.store_payment_methods_config_id,
                order_amount: this.displayCartTotalPrice,
                confirm_url: `${config.redirectUri}${this.toPaymentPagePath('linePay')}`,
                cancel_url: `${config.redirectUri}${this.toPaymentPagePath('linePay')}`,
                products_info: [...productsInfo, ...additionalFees],
            }
            await this.$store.dispatch('payment/linePayRequest', sendData)
        },
        toPaymentPagePath(paymentType) {
            const process = 'orderPayment'
            const { store, method } = this.getUrlParameters
            let path = `/${store}/${process}/${method}/${this.areaId}/${this.tableIndex}/${paymentType}/${this.orderNumber}`
            return path
        },
        toPayment(paymentType) {
            const path = this.toPaymentPagePath(paymentType)
            this.$router.push(path)
        },
        async createOnlineOrder(paymentType) {
            try {
                commonUtilities.createLoading('訂單建立中', '請稍後')
                let payment = JSON.parse(JSON.stringify(this.getPayment))
                
                // 從 Vuex store 讀取發票資料
                const invoiceTypeIndex = this.invoiceTypeIndex ?? 0
                const invoiceTypeNames = ["紙本發票", "手機載具", "統一編號", "愛心碼"]
                
                // 根據發票類型索引決定發票號碼
                let invoiceNumber = null
                if (invoiceTypeIndex === 0) {
                    // 紙本發票：不設定發票號碼
                    invoiceNumber = null
                } else if (invoiceTypeIndex === 1) {
                    invoiceNumber = this.invoiceCarrier
                } else if (invoiceTypeIndex === 2) {
                    invoiceNumber = this.invoiceVatNumber
                } else if (invoiceTypeIndex === 3) {
                    invoiceNumber = this.invoiceNpoBan
                }
                
                // 保持向後相容的 invoiceType 物件結構
                const invoiceType = {
                    type: invoiceTypeNames[invoiceTypeIndex],
                    invoiceNumber: invoiceNumber
                }
                
                payment.paymentType = paymentType
                payment.pointQuantity = this.isPointUsed ? this.pointQuantity : 0
                payment.comment = this.comment
                payment.couponTotalValue = this.getSelectedCouponValue
                payment.usedCoupon = this.$store.getters["cart/selectedCoupons"]
                payment.cart = this.cart
                payment.serviceFee = this.serviceFee
                payment.displayServiceFee = this.displayServiceFee
                payment.shippingFee = this.shippingFee
                payment.displayShippingFee = this.displayShippingFee
                payment.paymentPrice = this.displayCartTotalPrice
                payment.totalPrice = this.getCartTotalPrice
                payment.invoiceType = invoiceType
                payment.consumptionPattern = this.consumptionPattern
                //Add By Bryant 2025/08/25 Begin
                payment.userMobileTail = this.userMobileTailInput
                //Add By Bryant 2025/08/25 End
                // 統一編號來自 payment.vatNumber（由 deliveryEdit 組件設定）
                payment.buyerTaxId = this.getPayment.vatNumber || null

                // 用戶資料是否有更新
                payment.userDataChanged = this.userDataChanged
                // 用戶輸入匡的暱稱
                payment.userName = this.userNameInput
                // 用戶輸入匡的手機
                payment.userMobile = this.userMobileInput
                await this.$store.commit("cart/setPayment", payment)
                await this.$store.dispatch('order/createOnlineOrder')
                commonUtilities.closeLoading()
                await commonUtilities.delay(300)
            } catch (error) {
                commonUtilities.createToast('error', '訂單建立失敗', `${error}`)
                throw error
            }
        },
        scrollToInput() {
            const pointInput = this.$refs.pointInput
            this.scrollTo(pointInput)
        },
        scrollToComment() {
            const commentTextarea = this.$refs.commentTextarea
            this.scrollTo(commentTextarea)
        },
        scrollTo(el) {
            el.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'start',
            });
        },
        backToOrdering() {
            const { store, method, areaId, tableIndex } = this.getUrlParameters
            const path = `/${store}/ordering/${method}/${areaId}/${tableIndex}`
            this.$router.push(path)
        },
        deleteProduct(index) {
            let cart = JSON.parse(JSON.stringify(this.cart))
            cart.splice(index, 1)
            this.$store.commit("cart/setCart", cart)
        },
        // 驗證外送資訊
        validateDeliveryInfo() {
            const consumptionModeInfo = this.$refs.consumptionModeInfo
            if (!consumptionModeInfo) {
                commonUtilities.createToast("error", "無法取得外送資訊組件")
                return false
            }
            
            // 呼叫 ConsumptionModeInfo 的驗證方法
            return consumptionModeInfo.validateDeliveryInfo()
        },
        // 驗證發票資訊
        validateInvoiceInfo() {
            const consumptionModeInfo = this.$refs.consumptionModeInfo
            if (!consumptionModeInfo) {
                commonUtilities.createToast("error", "無法取得消費模式資訊組件")
                return false
            }
            
            // 取得 InvoiceSelector 的 ref（透過 ConsumptionModeInfo）
            const invoiceSelectorRef = consumptionModeInfo.$refs.invoiceSelectorRef
            if (!invoiceSelectorRef) {
                // 如果沒有 InvoiceSelector（發票功能未啟用），直接通過
                return true
            }
            
            // 呼叫 InvoiceSelector 的驗證方法
            const isValid = invoiceSelectorRef.validate()
            if (!isValid) {
                commonUtilities.createToast('error', '請檢查發票資訊格式')
                return false
            }
            
            return true
        },
    },
}
</script>
<style lang="scss" scoped>
.confirm_page {
    width: 100%;
    padding: 0 5%;
    flex-grow: 1;
    font-size: 16px;
    font-weight: 400;
    font-family: PingFang SC;
    padding-bottom: 50px;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #fff;
}

.backToOrdering {
    width: 80px;
    height: 36px;
    border: none;
    border-radius: 30px;
    color: #000;
    font-size: 14px;
    background-color: #EEEEEE
}

.order_note {
    width: 100%;
    padding: 15px 5%;
    height: 90px;
    border: 1px solid #DDDDDD;
    border-radius: 12px;
    margin-top: 10px;
    font-size: 18px;
}

.usePoint {
    font-size: 24px;

    input[type=checkbox] {
        width: 30px;
        height: 30px;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        border: 1px solid #DDDDDD;
        border-radius: 8px;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    input:checked {
        color: black;
    }

    input:checked::before {
        content: '\2714';
        font-size: 24px;
        color: black;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    input[type=number] {
        width: 80px;
        height: 44px;
        border: 1px solid #DDDDDD;
        border-radius: 10px;
        margin: 0 10px;
        text-align: center;
        font-size: 24px;
    }

    input[type=number]:focus::placeholder {
        color: transparent;
    }
}

.tabs {
    flex-shrink: 0;
    margin: 20px 0;

    button {
        flex-shrink: 0;
        border-radius: 30px;
        background-color: #DDDDDD;
        color: #000;
        border: none;
        height: 44px;
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px 10px;
        font-size: 16px;
        line-height: 0;
        border-radius: 0;
        margin: 0 1px;
    }

    button:nth-child(1) {
        border-radius: 8px 0 0 8px;
    }

    button:last-child {
        border-radius: 0 8px 8px 0;
    }

    .tabed {
        color: #000;
        background-color: #FBCB02;
        flex-shrink: 0;
    }
}

.total_price {
    width: 100%;
    margin: 0 0 20px;
    padding: 20px 0;
    border-top: 1px dotted #000;
    border-bottom: 1px dotted #000;
    font-size: 18px;
}

.coupons_container {
    -ms-overflow-style: none;
    scrollbar-width: none;
    height: 360px;
    width: 100%;
    margin-bottom: 20px;
}

.coupons_container ::-webkit-scrollbar {
    display: none;
}

.coupon_list {
    width: 100%;
    margin-top: 15px;
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 30px;
    --scrollbar-width: 0px;
    --mask-height: 100px;
    --mask-image-content: linear-gradient(to bottom,
            black,
            black var(--mask-height),
            black calc(100% - var(--mask-height)),
            transparent);
    --mask-size-content: calc(100% - var(--scrollbar-width)) 100%;
    --mask-image-scrollbar: linear-gradient(black, black);
    --mask-size-scrollbar: var(--scrollbar-width) 100%;
    mask-image: var(--mask-image-content), var(--mask-image-scrollbar);
    mask-size: var(--mask-size-content), var(--mask-size-scrollbar);
    mask-position: 0 100%, 100% 100%;
    mask-repeat: no-repeat, no-repeat;
}

.invoice_input {
    background-color: #fff;
    flex-grow: 1;
    height: 44px;
    border: none;
    font-size: 18px;
    color: #000;

    input {
        border: none;
        border: 1px solid #dddddd;
        border-radius: 6px;
        padding: 0 10px;
        height: 100%;
    }

    // input:focus {
    //     outline: none;
    //     border: none;
    //     -webkit-appearance: none;
    //     /* 针对部分 WebKit 内核的浏览器，如 Chrome 和 Safari */

    // }
}

.form_cell {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    margin-bottom: 15px;
    font-size: 16px;
    color: #000;
    font-weight: 400;

    input {
        width: 100%;
        height: 44px;
        border: none;
        background-color: #fff;
        font-size: 18px;
        color: #000;
        border-radius: 6px;
        padding: 0 10px;
        margin-top: 6px;
        border: 1px solid #dddddd;
    }

    ::placeholder {
        color: rgba($color: #000000, $alpha: 0.3);
    }
}

.label_title {
    font-weight: 500;
    font-size: 16px;
    font-family: PingFang SC;
    margin-bottom: 5px;

    .must {
        color: #c0462e;
        letter-spacing: 1px;
        margin-left: 4px;
    }
}

.avatar {
    margin-right: 10px;
    width: 86px;
    height: 86px;
    border-radius: 50%;
    border: 3px solid #facb00;
    flex-shrink: 0;
}
</style>
